import { render, staticRenderFns } from "./FlowContentEdit.vue?vue&type=template&id=164a1926&"
import script from "./FlowContentEdit.vue?vue&type=script&lang=js&"
export * from "./FlowContentEdit.vue?vue&type=script&lang=js&"
import style0 from "./FlowContentEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports